<template>
  <ContentWrapperControl
    no_bottom
    class="min-h-screen bg-primary flex flex-col items-center overflow-y-auto pb-4"
  >
    <ModalControl
      @closed="otp.show_modal = false"
      :dismiss="false"
      :show="otp.show_modal"
      :title="lang('lbl_0000165')"
    >
      <div class="mt-3 mb-3 text-center">{{ lang("lbl_0000371") }}</div>
      <OTPControl
        @success="success"
        @failed="failed"
        @showloader="showLoader"
        @hideloader="hideLoader"
        :election="true"
        :type="otp.type"
        :pin="otp.pin"
        :mobile="mobile"
        :email="email"
        :name="name"
      >
      </OTPControl>
    </ModalControl>
    <ModalControl
      @closed="otp.show_error = false"
      :dismiss="false"
      :show="otp.show_error"
      :title="lang('lbl_0000025')"
      theme="error"
    >
      <div class="text-center text-red-600 mt-6 mb-6">
        {{ otp.error_message }}
      </div>
      <div class="flex justify-center">
        <ButtonControl
          theme="error"
          @click="
            otp.show_error = false;
            otp.show_modal = true;
          "
        >
          {{ lang("lbl_0000349") }}
        </ButtonControl>
      </div>
    </ModalControl>
    <div>
      <!-- <span class="font-bold text-primary">{{ this.election.title }}</span> -->
      <div
        class="bg-white rounded-lg shadow-md mt-4 p-5 flex flex-col items-start text-gray-800 leading-normal"
      >
        <ElectionPolicyControl />
        <ButtonControl class="w-full" @click="startVoting">
          {{ this.lang("lbl_0000015") }}
        </ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import ElectionPolicyControl from "@/components/controls/ElectionPolicyControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import OTPControl from "@/components/controls/OTPControl.vue";
import mixin from "@/mixin.js";
import GA from "@/services/GA";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    ElectionPolicyControl,
    ButtonControl,
    ModalControl,
    OTPControl,
  },
  data() {
    return {
      name: "",
      username: "",
      password: "",
      mobile: "",
      email: "",
      election: {
        code: null,
        title: null,
        date: null,
      },
      otp: {
        show_modal: true,
        type: 1,
        pin: null,
        error_message: "",
        show_error: false,
      },
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("hidenavbar");

    let state = this.$store.state;
    this.username = state.info.username;
    this.password = state.password;
    this.email = state.info.email;

    if (!state.ga.code) {
      this.election.code = state.ga.code;
      this.election.title = state.ga.title;
      this.election.date = state.ga.date;
      this.loadElection();
      return;
    }
  },
  methods: {
    success() {
      let state = this.$store.state;
      // state.otp_login = true;
      // this.makeOTPLoginCookie(state.hash);
      // this.$emit("login");
      // this.$router.push("/dashboard");
      this.otp.show_modal = false;
      state.ga.user.has_agreed = true;
    },
    failed(message) {
      this.otp.show_modal = false;
      this.otp.error_message = message;
      this.otp.show_error = true;
    },
    showLoader() {
      this.$emit("showloader");
    },
    hideLoader() {
      this.$emit("hideloader");
    },
    loadElection() {
      this.$emit("showloader");
      GA.getCurrentElection()
        .then((response) => {
          if (response.status === 200) {
            const { code, title, date } = response.data.data;

            this.$store.state.ga.code = code;
            this.election.code = code;
            this.$store.state.ga.title = title;
            this.election.title = title;
            this.$store.state.ga.date = date;
            this.election.date = date;

            console.log(this.$store.state.ga);
            this.loadCandidates();
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    loadCandidates() {
      this.$emit("showloader");
      GA.getAllCandidates(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            const { candidates } = response.data.data;
            this.$store.state.ga.candidates = candidates;
            console.log(candidates);
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    startVoting() {
      this.$emit("showloader");
      let state = this.$store.state;
      GA.start(state.ga.code, state.ga.user.secret_key)
        .then((response) => {
          let data = response.data.data;
          state.ga.user.start_date = response.data.timestamp;
          state.ga.user.voter_key = data.voter_key;
          state.ga.user.ballot_number = data.ballot_no;
          state.ga.user.total_votes = data.total_votes;
          this.$router.push("/ga/vote");
        })
        .catch(function (error) {
          this.$emit("error", error);
        });
    },
  },
};
</script>
